/**
 * Survey timing overview:
 *
 * - Users have 2 weeks (SURVEY_FILLOUT_WINDOW_WEEKS) from a survey's start date
 *   to fill it out. After that, the banner text switches to "so bald wie möglich".
 *
 * - Points and a voucher are only given for a survey filled out within 6 weeks
 *   (SURVEY_DETECTION_WINDOW_WEEKS) from its start date, a rule of the study team.
 *   The cronjob only checks within this window. After it, staff can still record
 *   the fillout with the on-demand check, without points and voucher.
 *
 * - The frontend banner is hidden after 6 weeks for the same reason.
 *   The backend also stops returning surveys older than 6 weeks so that
 *   newer surveys can surface instead of being blocked by an expired one.
 */

/** Weeks from survey start date that users are expected to fill out the survey. */
export const SURVEY_FILLOUT_WINDOW_WEEKS = 2;

/**
 * Maximum weeks after a survey's start date during which a detected completion
 * still gets points/vouchers.
 * Also used to hide the frontend banner and filter out expired surveys.
 */
export const SURVEY_DETECTION_WINDOW_WEEKS = 6;

/**
 * MAX_HORIZON and MAX_WAVE are the highest values a SurveyLink can hold.
 * HORIZON_MODULO and WAVE_MODULO are not range limits. Code uses them to
 * turn a survey index into a horizon and a wave number.
 * Backend and frontend both use these constants.
 */
export const MAX_HORIZON = 4;
export const HORIZON_MODULO = 3;
export const MAX_WAVE = 3;
export const WAVE_MODULO = 3;
export type Horizon = 0 | 1 | 2 | 3 | typeof MAX_HORIZON;
export type Wave = 0 | 1 | 2 | typeof MAX_WAVE;

/**
 * Staff count the baseline survey as "Horizon 1", so the first REOCCURING round
 * (horizon 1 in the database) is "Horizon 2" for them. The wave number is the same.
 */
export const staffHorizon = (horizon: number): number => horizon + 1;
